import script from "./Calendar.vue?vue&type=script&lang=ts&setup=true"
export * from "./Calendar.vue?vue&type=script&lang=ts&setup=true"

import "./Calendar.vue?vue&type=style&index=0&id=1bda9c28&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/bookonline/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bda9c28"]])

export default __exports__